export enum FeedbackStatus {
  SUBMITTED = "SUBMITTED",
  SOLUTION_DELIVERED = "SOLUTION_DELIVERED",
  BUILDING = "BUILDING",
  WONT_BUILD = "WONT_BUILD",
}

export enum FeedbackStatusLabel {
  SUBMITTED = "Submitted",
  SOLUTION_DELIVERED = "Solution Delivered",
  BUILDING = "Building",
  WONT_BUILD = "Won't Build",
}

export enum FeedbackSentiment {
  NEGATIVE = "NEGATIVE",
  POSITIVE = "POSITIVE",
  NEUTRAL = "NEUTRAL",
}

export enum FeedbackSentimentLabel {
  NEGATIVE = "Negative",
  POSITIVE = "Positive",
  NEUTRAL = "Neutral",
}

export enum FeedbackImportance {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export enum FeedbackImportanceLabel {
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low",
}
